import { getObjectUtil } from 'packages/src'
import EXERCISES_PATH from '../../constants/path'

const getEquipmentFiltersExercisesSelect = state => getObjectUtil(
  state,
  EXERCISES_PATH.EQUIPMENT_FILTER
)

export default getEquipmentFiltersExercisesSelect
